import styled from "styled-components";

export const InquiryOnholdModalStyle = styled.div`

`;
